var exports = {
  "s": "CommentBoxContainer__9vE6Ia",
};

module.exports = exports;
